import { AiFillFacebook, AiOutlineInstagram, AiOutlineLinkedin, AiOutlineTwitter } from 'react-icons/ai';

import './FooterSocialMedia.css';

function Footer() {
  const iconColor = '#273B60';
  const iconSize = 32;

  return (
    <div className='footer-social-media'>
      <h1 className='footer-social-media-header'>Safecert</h1>
      <div className='footer-social-media-text-container'>
        <div className='footer-social-media-text1'>Smart Certificates For</div>
        <div className='footer-social-media-text2'>Smart Organizations</div>
      </div>
      <br/>
      <div className='footer-social-media-icon-container'>
        {/* <Link href='https://www.facebook.com/globalcertificate/' isExternal style={{ userSelect: 'none' }}> */}
          <AiFillFacebook size={iconSize} color={iconColor}/>
        {/* </Link> */}
        {/* <Link href='https://www.instagram.com/globalcert_/' isExternal style={{ userSelect: 'none' }}> */}
          <AiOutlineInstagram size={iconSize} color={iconColor}/>
        {/* </Link> */}
        {/* <Link href='https://twitter.com/GlobalCert2' isExternal style={{ userSelect: 'none' }}> */}
          <AiOutlineTwitter size={iconSize} color={iconColor}/>
        {/* </Link> */}
        {/* <Link href='https://www.linkedin.com/company/globalcert/' isExternal style={{ userSelect: 'none' }}> */}
          <AiOutlineLinkedin size={iconSize} color={iconColor}/>
        {/* </Link> */}
      </div>
    </div>
  );
}

export default Footer;
